/**
 * Block 12 PR-H1 Round 2 fix #1 + Round 3 — shared composition row utilities.
 *
 * Single source of truth для filtering пустых composition rows: используется
 * UI рендерером (SectionComposition.tsx) и PDF рендерером (renderQuoteToPdf.ts)
 * чтобы оба показывали одно и то же. Раньше PDF имел приватную копию, а UI
 * не имел filter вообще — расхождение визуально показывалось в КП.
 *
 * **Семантика «empty» (3 уровня exemptions):**
 * 1. **Custom rows (UUID IDs не в DEFAULT_COMPOSITION_ROWS)** — никогда не
 *    empty. Пользователь явно их добавил через «+ Добавить строку самому».
 * 2. **Seeded rows (Round 3, `seeded: true` marker)** — никогда не empty.
 *    Default rows которые seedFromAnketa пометил seeded (toggle items вкл. в
 *    Anketa) visible с пустыми Тип/Бренд (заполняются вручную в КП).
 * 3. **Default rows без seed** — empty если `itemType` И `brand` оба пусты
 *    (null|undefined|''-after-trim или literal '—').
 *
 * `name` field в check НЕ участвует — default row с заполненным name но пустыми
 * itemType+brand всё равно считается «не заполнена» (пользователь не подтвердил
 * содержимое). Это совпадает с предыдущей логикой PDF render (renderQuoteToPdf.ts
 * Phase D11 follow-up #2 Bug E).
 */

import { DEFAULT_COMPOSITION_ROWS } from './compositionRows';

const DEFAULT_ROW_IDS: ReadonlySet<string> = new Set(DEFAULT_COMPOSITION_ROWS.map((r) => r.id));

const isFieldEmpty = (v: string | null | undefined): boolean => {
  if (v === null || v === undefined) return true;
  const trimmed = v.trim();
  return trimmed === '' || trimmed === '—';
};

export interface CompositionRowEmptyCheck {
  id: string;
  itemType: string;
  brand: string;
  /** PR-H1 Round 3 — seeded marker (см. CompositionRow в types.ts). */
  seeded?: boolean;
}

export function isCompositionRowEmpty(row: CompositionRowEmptyCheck): boolean {
  if (!DEFAULT_ROW_IDS.has(row.id)) return false;
  if (row.seeded) return false;
  return isFieldEmpty(row.itemType) && isFieldEmpty(row.brand);
}
